<template>
  <div class="container">
    <section>
      <div class="row justify-content-center">
        <div class="col-md-6">
          <div v-if="$route.params.code || this.validatedCode">
            <div class="card text-center">
              <div class="card-header">
                <h1>{{ manualData.topic }}</h1>
                <h6>SQE Manual (code: {{ this.validatedCode }})</h6>
              </div>
              <div class="card-body">
                <div v-if="fetchStatus === 'submitted'">
                  <div v-if="page === 'accessGranted'">
                    <h3>Successfully registered!</h3>
                    <p class="lead">
                      The MCQs from this title have been added to youe ULaw SQE
                      app account. You can access this on Web, iOS and Android
                      straight away by clicking the links below
                    </p>
                  </div>
                  <div class="container">
                    <div class="row">
                      <div class="col-sm">
                        <p>Web users</p>
                        <div class="row justify-content-center my-3">
                          <b-button
                            style="min-width: 161px"
                            :href="webLoginLink"
                            variant="primary"
                            >Launch Web App</b-button
                          >
                        </div>
                      </div>
                      <div class="border-right"></div>
                      <div class="col-sm">
                        <p>Mobile users</p>
                        <div class="row justify-content-center my-3">
                          <b-button
                            style="min-width: 161px"
                            :href="mobileLoginLink"
                            variant="primary"
                            >Launch Mobile App</b-button
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                  <p>Dont have the app ?</p>

                  <div class="container">
                    <div class="row">
                      <div class="col-sm">
                        <div class="row justify-content-center my-3">
                          <a
                            href="itms-apps://itunes.apple.com/app/apple-store/id1536809275?mt=8"
                            variant="primary"
                            ><img
                              src="img/apple.svg"
                              style="min-width: 161px; min-height=40px;"
                          /></a>
                        </div>
                      </div>
                      <div class="col-sm">
                        <div class="row justify-content-center my-3">
                          <a
                            href="https://play.google.com/store/apps/details?id=com.ulaw.sqe"
                            variant="primary"
                            ><img
                              src="img/android.svg"
                              style="min-width: 161px; min-height=40px;"
                          /></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else-if="fetchStatus === 'done'">
                  <p>
                    Thank you for purchasing this SQE Manual. To access your
                    free MCQs, please login or register for a free account
                  </p>
                  <div v-if="page === 'landing'">
                    <div class="row justify-content-center">
                      <b-button
                        @click="page = 'newUser'"
                        variant="primary"
                        class="margin-10"
                        >New Users</b-button
                      >

                      <b-button
                        @click="page = 'existingUser'"
                        variant="primary"
                        class="margin-10"
                        >Existing Users</b-button
                      >
                    </div>
                    <div class="row justify-content-center">
                      <b-button
                        @click="page = 'ulawStudent'"
                        variant="primary"
                        class="margin-10"
                        >ULaw Students</b-button
                      >
                    </div>
                    <p>
                      Note: If you are a ULaw SQE student, or you purchased this
                      book from ULaw Online, then you will already have access
                      via your account!
                    </p>
                  </div>
                  <div v-if="page === 'ulawStudent'">
                    <h3>ULaw Students</h3>
                    <div v-if="validatedCode === 'hyy8'">
                      <p>
                        Enter the email address for your ULaw SQE account below,
                        and these free questions will be added to your account
                      </p>
                      <b-form-group
                        id="input-group-email"
                        label="Email address:"
                        label-for="input-email"
                        description="We'll never share your email with anyone else."
                      >
                        <b-form-input
                          id="input-email"
                          v-model="form.email"
                          type="email"
                          required
                          placeholder="Enter your email address"
                        ></b-form-input>
                      </b-form-group>
                      <b-button
                        @click="applyCodeToEmailAddress()"
                        variant="primary"
                        >Get Access</b-button
                      >
                      <b-button @click="page = 'landing'" variant="light"
                        >Back</b-button
                      >
                    </div>
                    <div v-else>
                      <p>
                        If you are studying an SQE course with The University of
                        Law, you should already have access to these questions!
                        Login to the app or web platform to access them
                      </p>
                      <b-button @click="page = 'landing'" variant="light"
                        >Back</b-button
                      >
                    </div>
                  </div>
                  <div v-if="page === 'newUser'">
                    <h3>New Users - Register</h3>
                    <b-form>
                      <b-form-group
                        id="input-group-name"
                        label="Name:"
                        label-for="input-name"
                      >
                        <b-form-input
                          id="input-name"
                          v-model="form.name"
                          type="text"
                          required
                          placeholder="Enter your name"
                        ></b-form-input>
                      </b-form-group>

                      <b-form-group
                        id="input-group-email"
                        label="Email address:"
                        label-for="input-email"
                        description="We'll never share your email with anyone else."
                      >
                        <b-form-input
                          id="input-email"
                          v-model="form.email"
                          type="email"
                          required
                          placeholder="Enter your email address"
                        ></b-form-input>
                      </b-form-group>

                      <b-form-group
                        id="input-group-password"
                        label="Password:"
                        label-for="input-password"
                        description="8 characters, including 1 upper case and one number"
                      >
                        <b-form-input
                          id="input-password"
                          v-model="form.password"
                          type="password"
                          required
                          placeholder="Choose a password"
                        ></b-form-input>
                      </b-form-group>
                      <p v-html="responseMessage"></p>

                      <b-button @click="registerUser()" variant="primary"
                        >Get Access</b-button
                      >
                      <b-button @click="page = 'landing'" variant="light"
                        >Back</b-button
                      >
                    </b-form>
                  </div>
                  <div v-if="page === 'existingUser'">
                    <h3>Existing Users - Log In</h3>
                    <b-form>
                      <b-form-group
                        id="input-group-email"
                        label="Email address:"
                        label-for="input-email"
                        description="We'll never share your email with anyone else."
                      >
                        <b-form-input
                          id="input-email"
                          v-model="loginForm.email"
                          type="email"
                          required
                          placeholder="Enter your email address"
                        ></b-form-input>
                      </b-form-group>

                      <b-form-group
                        id="input-group-password"
                        label="Password:"
                        label-for="input-password"
                        description="We'll never share your email with anyone else."
                      >
                        <b-form-input
                          id="input-password"
                          v-model="loginForm.password"
                          type="password"
                          required
                          placeholder="Enter your password"
                        ></b-form-input>
                      </b-form-group>
                      <p v-html="responseMessage"></p>
                      <b-button @click="loginUser()" variant="primary"
                        >Get Access</b-button
                      >
                      <b-button @click="page = 'landing'" variant="light"
                        >Back</b-button
                      >
                    </b-form>
                  </div>
                </div>
                <div v-else-if="fetchStatus === 'in progress'">
                  <h4>Fetching your manual information</h4>
                </div>
                <div v-else-if="fetchStatus === 'error'">
                  <h4>
                    Error fetching manual information for
                    {{ $route.params.code }}
                  </h4>
                </div>
              </div>
            </div>
          </div>

          <div v-else>
            <div class="card text-center">
              <div class="card-header">
                <img src="img/ulaw-logo-square.png" class="ulaw-logo" />
                <h1>SQE Manuals - MCQ Redemption</h1>
              </div>
              <div class="card-body">
                <p class="lead">
                  If you have purchased a ULaw SQE Manual, you can use this site
                  to redeem your MCQs in the ULaw SQE app. Please scan the QR
                  code in the front of your manual, or enter the 4-digit code
                  associated with it below
                </p>
                <b-form>
                  <b-form-group
                    id="input-group-code"
                    label="Code:"
                    label-for="input-code"
                  >
                    <b-form-input
                      id="input-code"
                      v-model="form.code"
                      type="text"
                      required
                      placeholder=""
                    ></b-form-input>
                  </b-form-group>
                  <b-button
                    @click="submitCode"
                    variant="primary"
                    class="margin-10"
                    >Submit</b-button
                  >
                </b-form>

                <p class="response-message" v-html="responseMessage"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
const validateCode = (code) => {
  const requestedCode = code.toLowerCase().trim(); // basic sanitisation
  const regex = RegExp(/^(s|h)(\d|\w){3}$/);
  console.log(`Regex test on ${requestedCode}: ${regex.test(requestedCode)}`);

  return regex.test(requestedCode);
};

export default {
  name: 'Home',
  data() {
    return {
      fetchStatus: 'in progress',
      form: {
        email: '',
        name: '',
        password: '',
        code: ''
      },
      loginForm: {
        email: '',
        password: ''
      },
      accessInfo: {
        token: '',
        collectionId: '',
        userId: ''
      },
      validatedCode: '',
      emailMessage: 'Hi - your free MCQs are ready in your ULaw SQE account',
      manualData: {
        manualName: ''
      },
      responseMessage: '',
      page: 'landing'
    };
  },
  computed: {
    webLoginLink: function () {
      if (this.accessInfo && this.accessInfo.token) {
        return `https://practice.law.ac.uk?st=${this.accessInfo.token}`;
      } else return `https://practice.law.ac.uk`;
    },
    mobileLoginLink: function () {
      let url = `ulawsqe://e.law.ac.uk/intent?`;
      if (this.accessInfo && this.accessInfo.userId) {
        url += `u=${this.accessInfo.userId}`;
      }
      if (this.accessInfo && this.accessInfo.token) {
        url += `&st=${this.accessInfo.token}`;
      }
      return url;
    }
  },
  methods: {
    submitCode: async function () {
      console.log(`Submitted code: ${this.form.code}`);
      if (validateCode(this.form.code)) {
        this.responseMessage = 'Checking code';
        this.fetchData(this.form.code);
      } else {
        this.responseMessage = `The code you entered, '${this.form.code}' is not valid. Please check your manual and try again. Valid codes are 4 characters long and begin with an 's' or 'h'`;
      }
    },
    registerUser: async function () {
      try {
        let result = await this.$http.post(
          `https://labs-api-prod.synap.ac/ulaw/code/register`,
          {
            name: this.form.name,
            email: this.form.email,
            password: this.form.password,
            bookCode: this.validatedCode
          }
        );
        console.log(`Synap Org api request sent: ${JSON.stringify(result)}`);
        console.dir(result);
        this.responseMessage = result.data.message;
        this.accessInfo.token = result.data.token;
        this.accessInfo.userId = result.data.user.id;
        this.accessInfo.collectionId = result.data.collectionId;
        this.page = 'accessGranted';

        this.fetchStatus = 'submitted';
      } catch (error) {
        this.responseMessage = error.response.data.message;
      }
    },
    loginUser: async function () {
      try {
        let result = await this.$http.post(
          `https://labs-api-prod.synap.ac/ulaw/code/login`,
          {
            password: this.loginForm.password,
            email: this.loginForm.email,
            bookCode: this.validatedCode
          }
        );
        this.accessInfo.token = result.data.token;
        this.accessInfo.userId = result.data.user.objectId;
        this.accessInfo.collectionId = result.data.collectionId;
        this.responseMessage = result.data.message;
        this.page = 'accessGranted';
        /*        if (result.data.isNew === true) {
          this.responseMessage = `An invite has been sent to ${this.form.email} - please follow the instructions to set up your new account`;
        } else {
          this.responseMessage = `MCQs have been added to your account. Open the app or login on the website to access them`;
        } 
        8*/
        this.fetchStatus = 'submitted';
      } catch (error) {
        console.log(`Error submitting webhook: ${error}`);
      }
    },
    applyCodeToEmailAddress: async function () {
      console.log(
        `Apply code ${this.validatedCode} to email ${this.form.email}`
      );
      try {
        let result = await this.$http.post(
          `https://labs-api-prod.synap.ac/ulaw/code/applyToEmail`,
          {
            email: this.form.email,
            bookCode: this.validatedCode
          }
        );
        this.accessInfo.token = result.data.token;
        this.accessInfo.userId = result.data.user.objectId;
        this.accessInfo.collectionId = result.data.collectionId;
        this.responseMessage = result.data.message;
        this.page = 'accessGranted';
        /*        if (result.data.isNew === true) {
          this.responseMessage = `An invite has been sent to ${this.form.email} - please follow the instructions to set up your new account`;
        } else {
          this.responseMessage = `MCQs have been added to your account. Open the app or login on the website to access them`;
        } 
        8*/
        this.fetchStatus = 'submitted';
      } catch (error) {
        console.log(`Error submitting webhook: ${error}`);
      }
    },
    done: function () {
      this.fetchStatus = 'done';
      this.responseMessage = '';
      this.form.email = '';
      this.form.name = '';
    },
    fetchData: async function (code) {
      this.fetchStatus = 'in progress';
      try {
        let res = await this.$http.get(
          `https://labs-api-prod.synap.ac/ulaw/code/${code}`
        );
        this.validatedCode = code;
        this.manualData = res.data;
        this.fetchStatus = 'done';
      } catch (error) {
        console.log(`Error fetching code: ${error}`);
        this.responseMessage = 'Error fetching code';
        this.fetchStatus = 'error';
      }
    }
  },
  mounted() {
    if (this.$route.params.code) {
      this.validatedCode = this.$route.params.code;
      this.fetchData(this.validatedCode);
    }
  }
};
</script>

<style scoped>
.ulaw-logo {
  width: 120px;
}
.margin-10 {
  margin: 10px;
}
section {
  padding-top: 5rem;
}
</style>
